import $ from 'jquery';
import 'bootstrap/js/dist/modal';
import Vue from 'vue';

const DATA_KEY = 'bs.modal';

export const EVENT_KEY = `.${DATA_KEY}`;
export const EVENT_HIDE = `hide${EVENT_KEY}`;
export const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
export const EVENT_SHOW = `show${EVENT_KEY}`;
export const EVENT_SHOWN = `shown${EVENT_KEY}`;

export const defaults = Vue.observable({
    fullscreen: false,
});

export const Wrapper = {
    functional: true,
    props: {
        fullscreen: {
            type: Boolean,
            default: defaults.fullscreen,
        },
    },
    render(h, {props, slots}) {
        return (
            <div class={{
                'modal': true,
                'modal-fullscreen': props.fullscreen,
                'fade': true,
            }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        {slots().default}
                    </div>
                </div>
            </div>
        )
    }
}

export const Mixin = {
    methods: {
        show() {
            $(this.$el).modal('show');
        },
        hide() {
            $(this.$el).modal('hide');
        },
    },
    beforeDestroy() {
        $(this.$el).modal('dispose');
    },
}
